<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>产品</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.rid">
                <el-input v-model="queryParams.rid" placeholder="请输入rid" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.master_rid" placeholder="请输入主rid" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="queryParams.name" placeholder="请输入名称" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.product_licence_number">
                <el-input
                    v-model="queryParams.product_licence_number"
                    placeholder="请输入批准文号"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.product_common_name">
                <el-input
                    v-model="queryParams.product_common_name"
                    placeholder="请输入产品通用名"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type_code"
                    model_name="请选择类型"
                    :model_value_default="queryParams['type_code']"
                    select_value="value"
                    request_uri="dropdownProductTypeCode"
                    @onDropChange="onDropChange"
                    ref="type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="group_code"
                    model_name="请选择分组"
                    :model_value_default="queryParams['group_code']"
                    select_value="value"
                    request_uri="dropdownProductGroupCode"
                    :request_params="{ with_empty: true }"
                    @onDropChange="onDropChange"
                    ref="group_code_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>

                <el-button size="small" plain @click="flushProductState()" :loading="btnLoading">刷新产品状态</el-button>
                <el-button size="small" plain @click="flushProductWeight()" :loading="btnLoading">刷新产品权重</el-button>
                <el-button size="small" plain @click="flushProductSchedule()" :loading="btnLoading">刷新产品计划</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="product" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="product"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    in_array(item.prop, [
                                        'code',
                                        'name',
                                        'product_common_name',
                                        'product_licence_number',
                                        'manufacturer_name',
                                        'master_name'
                                    ])
                                "
                            >
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'productComponent',
    data() {
        return {
            draggable: {
                data_name: 'product'
            },
            btnLoading: false,
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                this.queryParams.row = 10;
                this.queryParams.product_licence_rid = this.postList.params.product_licence_rid;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        flushProductState() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushProductState']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushProductWeight() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushProductWeight']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushProductSchedule() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushProductSchedule']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code', 'name'])) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'product_common_name' || prop == 'product_licence_number') {
                this.$router.push({
                    path: '/productDetails',
                    query: {
                        id: row.product_licence_rid
                    }
                });
            } else if (prop == 'manufacturer_name') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.manufacturer_rid
                    }
                });
            } else if (prop == 'master_name' && row.master_rid) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.master_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('product_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('product_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('product', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).product;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'productLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'productDelete', row.name);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>